import { render, staticRenderFns } from "./ImportWarehouse.vue?vue&type=template&id=6ed128f0&scoped=true"
import script from "./ImportWarehouse.vue?vue&type=script&lang=ts"
export * from "./ImportWarehouse.vue?vue&type=script&lang=ts"
import style0 from "./ImportWarehouse.vue?vue&type=style&index=0&id=6ed128f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed128f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed128f0')) {
      api.createRecord('6ed128f0', component.options)
    } else {
      api.reload('6ed128f0', component.options)
    }
    module.hot.accept("./ImportWarehouse.vue?vue&type=template&id=6ed128f0&scoped=true", function () {
      api.rerender('6ed128f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/ImportWarehouse.vue"
export default component.exports